<template>
  <div>
    <router-link
      v-if="!item.children"
      :to="item.path"
      class="mt-1 group flex items-center px-2 py-2 text-sm leading-5 font-medium text-green-300 rounded-md hover:text-white hover:bg-green-700 focus:outline-none focus:text-white focus:bg-green-700 transition ease-in-out duration-150"
    >
      <icon
        set="outline"
        :name="item.meta.icon"
        class="mr-3 h-6 w-6 text-green-400 group-focus:text-green-300 transition ease-in-out duration-150"
      />
      {{ item.name }}
    </router-link>

    <button
      v-else
      @click="toggleSubnav(item.name)"
      class="mt-1 group w-full flex items-center pl-2 pr-1 py-2 text-sm leading-5 font-medium rounded-md text-green-300 rounded-md hover:text-white hover:bg-green-700 focus:outline-none focus:text-white focus:bg-green-700 transition ease-in-out duration-150"
    >
      <icon
        set="outline"
        :name="item.meta.icon"
        class="mr-3 h-6 w-6 text-green-400 group-focus:text-green-300 transition ease-in-out duration-150"
      />
      {{ item.name }}

      <icon
        set="outline"
        name="chevron-right"
        :class="{ 'rotate-90': isOpen(item.name) }"
        class="ml-auto h-5 w-5 transform group-hover:text-green-400 group-focus:text-green-400 transition-colors ease-in-out duration-150"
      />
    </button>

    <div v-show="isOpen(item.name)" v-if="item.children" class="mt-1">
      <router-link
        v-for="child in item.children"
        :to="item.path + '/' + child.path | paramFix"
        :key="child.name"
        class="subnav-base"
      >
        {{ child.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    item: Object
  },
  data() {
    return {
      subnavClass:
        "mt-1 group w-full flex items-center pl-11 pr-2 py-2 text-sm leading-5 font-medium text-green-300 rounded-md hover:text-white hover:bg-green-700 focus:outline-none focus:text-white focus:bg-green-700 transition ease-in-out duration-150",
      expanded: ["Orders", "Print"]
    };
  },
  computed: {},
  methods: {
    toggleSubnav(name) {
      if (this.expanded.includes(name)) {
        this.expanded = this.expanded.filter(i => i !== name);
      } else {
        this.expanded.push(name);
      }
    },
    isOpen(name) {
      return this.expanded.includes(name);
    }
  },
  filters: {
    paramFix: str => {
      return str.replace(/\/:[a-z].*\?/i, "");
    }
  }
};
</script>

<style scoped></style>
